import React, { useEffect, useRef } from 'react';
import ApiGrid, { ApiGridHandle } from '@components-clean/core/api-grid';
import { MonitoringToolKitTables } from '@interfaces-clean/observations.interface';
import SubjectMonitoringService from '@pages-clean/subject-monitoring/subject-hub/subject-monitoring.service';
import { useTranslation } from '@hooks/index';

type Props = {
    studyRef: string;
    reviewId: number;
};

const SubjectReviewActivityLogGrid = ({ studyRef, reviewId }: Props) => {
    const { t } = useTranslation('sm', {
        keyPrefix: 'monitoringToolkit.reviewActivityLogGrid',
    });

    const ref = useRef<ApiGridHandle>(null);

    // Refresh activity grid if told to (something that caused an entry to be added occurred)
    useEffect(() => {
        const subscription = SubjectMonitoringService.onRefreshSubjectsInEditReviewPanel().subscribe((changed) => {
            if (changed) {
                ref.current?.refreshData();
            }
        });

        return () => subscription.unsubscribe();
    }, []);

    return (
        <ApiGrid
            ref={ref}
            table={MonitoringToolKitTables.SubjectReviewActivityLog}
            gridParams={{
                grid: 'SubjectReviewActivityLog',
                reviewId: reviewId.toString(),
                studyRef,
            }}
            title={t('title')}
            testDataId="review-actions-grid"
            maxHeight="calc(100vh)"
            showAddIcon={false}
            showBulkUpdateIcon={false}
            showSendEmailIcon={false}
            gridDownloadDisabled
        />
    );
};

export default SubjectReviewActivityLogGrid;
